import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import PropertyNewsIconSvg from '@propertypal/shared/src/resources/logos/property-news-icon.svg';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  margin: 60px auto;
  padding: 0 20px;
  gap: 30px;
  align-items: center;

  h3 {
    font-size: 30px;
  }

  p {
    margin: 15px 0;
  }

  a {
    color: ${({ theme }) => theme.primary};

    &:hover {
      text-decoration: underline;
    }
  }

  @media (${mobileXXLargeMax}) {
    flex-direction: column;
  }
`;

export const PropertyNewsIcon = styled(PropertyNewsIconSvg)`
  flex: 0 0 95px;
  display: block;
`;
